import { Descendant, Element, Text } from "slate";

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { ICannedResponseAttachment } from "store/entities/canned-responses";

export interface ICannedResponsesProps {
  className?: string;
  items: ICannedResponseTag[];
  searchPhrase: string;
  onClose: () => void;
  onSearchResultsCountChange?: (count: number) => void;
  onSelect: (cannedResponseTagValue: ICannedResponseTagValue, method: CannedResponseInputMethod) => void;
  textareaWithCannedResponsesRef: React.RefObject<HTMLDivElement>;
  containerRef?: React.Ref<HTMLDivElement>;
}

export interface ICannedResponseTag {
  name: string;
  values: ICannedResponseTagValue[];
}

export interface ICannedResponseTagValue {
  id: string;
  text: string;
  richTextObj?: Descendant[];
  attachments?: ICannedResponseAttachment[];
}

export type CannedResponseInputMethod = "keyboard" | "mouse";

export interface ICannedResponseUsage {
  response: string;
  method: CannedResponseInputMethod;
}

export const replaceCannedResponseTagsWithVariables = (
  variablesMap: Map<string, string>,
  reqExp: RegExp,
  cannedResponseTags: ICannedResponseTag[]
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
) =>
  cannedResponseTags.map(item => ({
    name: item.name,
    values: item.values.map(canned => {
      const { richTextObj, text } = canned;
      const isCannedWithRichText = richTextObj !== null;

      if (isCannedWithRichText) {
        // FIXME: Fix this the next time the file is edited.
        // @ts-expect-error TS(7023): 'replaceTextWithVariables' implicitly has return t... Remove this comment to see the full error message
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        const replaceTextWithVariables = (nodes: Descendant[], variablesMap: Map<string, string>) =>
          nodes.map(node => {
            if (Text.isText(node)) {
              const newText = node.text.replace(reqExp, (key: string) => variablesMap.get(key) || key);
              return { ...node, text: newText };
            }

            if (Element.isElement(node)) {
              // replace variable node with text node because of canned inserting use case in ticket details RTE
              if (node.type === "textVariable") {
                return { text: variablesMap.get(node.content) || node.content };
              }

              // @ts-expect-error TS(7022): 'newChildren' implicitly has type 'any' because it... Remove this comment to see the full error message
              const newChildren = replaceTextWithVariables(node.children, variablesMap);
              return { ...node, children: newChildren };
            }

            return node;
          });

        // @ts-expect-error TS(2345): Argument of type 'Descendant[] | undefined' is not... Remove this comment to see the full error message
        const richTextObjWithVariables = replaceTextWithVariables(richTextObj, variablesMap);

        return {
          ...canned,
          richTextObj: richTextObjWithVariables,
          text: text.replace(reqExp, (key: string) => variablesMap.get(key) || key),
        };
      }

      return {
        ...canned,
        richTextObj: null,
        text: text.replace(reqExp, (key: string) => variablesMap.get(key) || key),
      };
    }),
  }));
